<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm4 md2 offset-md1>
        <v-layout column>
          <v-flex d-flex xs2 ><v-card height="80" align-content-center class="text-xs-center">
            <p v-t="{path: 'info.scopes.SCOPE1.TITLE', locale: version}"/>
          </v-card></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="1" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="2" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="3" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="4" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="5" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="6" :version="version" hover/></v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 ><v-card height="80" align-content-center class="text-xs-center">
            <p v-t="{path: 'info.scopes.SCOPE2.TITLE', locale: version}"/>
          </v-card></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="7" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="8" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="9" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="10" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="11" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="12" :version="version" hover/></v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 ><v-card height="80" align-content-center class="text-xs-center">
            <p v-t="{path: 'info.scopes.SCOPE3.TITLE', locale: version}"/>
          </v-card></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="13" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="14" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="15" :version="version" hover/></v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2 offset-sm2 offset-md0>
        <v-layout column>
          <v-flex d-flex xs2 ><v-card height="80" align-content-center class="text-xs-center">
            <p v-t="{path: 'info.scopes.SCOPE4.TITLE', locale: version}"/>
          </v-card></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="16" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="17" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="18" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="19" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="20" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="21" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="22" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="23" :version="version" hover/></v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 ><v-card height="80" align-content-center class="text-xs-center">
            <p v-t="{path: 'info.scopes.SCOPE5.TITLE', locale: version}"/>
          </v-card></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="3" item="24" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="25" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="2" item="26" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="27" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="28" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="29" :version="version" hover/></v-flex>
          <v-flex d-flex xs2><evaloe-item complexity="1" item="30" :version="version" hover/></v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
  </v-container>
</template>

<script>
  import EvaloeItem from '@/components/questionnaires/EvaloeItem'
  export default {
    name: 'grid',
    components: {
      'evaloe-item': EvaloeItem
    },
    data () {
      return {
        questionnaireItems: '',
        version: this.$auth.user().version,
        recommendations: ''
      }
    },
    mounted () {
      console.log(this.$auth.user().version)
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Grid.vue